import styled from "styled-components";

export const Wrapper = styled.div`
.filter{
    margin-bottom: 5px;
    display: flex;
    justify-content: right;
}
.pointer{
    cursor: pointer;
}
.scroll-button-container {
    display: flex;
    justify-content: center;
    align-items: center;
    .scroll-button {
        border: none;
        background: #131f28;
        padding: 15px;
        border-radius: 50%;
        
    }
}
`;
